// components/ReservationWarningModal.tsx

import { Dialog } from "./Dialog";
import { Button } from "./Button";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";

interface ReservationWarningModalProps {
  isOpen: boolean;
  onExtend: () => void;
  onCancel: () => void;
  timeRemaining: string;
  isExtending?: boolean;
}

export const ReservationWarningModal = ({
  isOpen,
  onExtend,
  onCancel,
  timeRemaining,
  isExtending = false,
}: ReservationWarningModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog isOpen={isOpen} onClose={() => {}} dismissible={false}>
      <div className="w-full max-w-md p-6">
        <div className="mb-4 flex justify-center">
          <div className="bg-ink/[0.07] rounded-full p-3">
            <AlertTriangle className="h-8 w-8" />
          </div>
        </div>

        <h2 className="mb-2 text-center text-xl font-bold text-ink">
          {t("reservation_session.warning_title")}
        </h2>

        <p className="mb-6 text-center text-sm text-ink-secondary">
          {t("reservation_session.warning_message", { time: timeRemaining })}
        </p>

        <div className="flex gap-3">
          <Button
            variant="secondary"
            size="medium"
            onClick={onCancel}
            disabled={isExtending}
            className="w-full"
          >
            {t("reservation_session.cancel_booking")}
          </Button>
          <Button
            size="medium"
            onClick={onExtend}
            isLoading={isExtending}
            className="w-full"
          >
            {t("reservation_session.extend_time")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
